/**
 * Gets a field from JSON trying both camelCase and snake_case keys
 * Matches the mobile app's json_utils.dart getJsonField function
 */
export const getJsonField = <T>(json: any, camelCaseKey: string): T | undefined => {
  // Convert camelCase to snake_case
  const snakeCaseKey = camelCaseKey.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
  return json[camelCaseKey] ?? json[snakeCaseKey];
};
